import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Text } from './atoms';
import DatePicker from 'containers/datepicker';

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-width: 280px;
    height: 42px;
    border: 1px solid #E3E3E3;
    border-radius: 8px;
    padding-left: 12px;
    padding-right: 12px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    
    &:hover {
      border: 1px solid ${theme?.colour?.primary ?? "#1DBD6B"};
    }

    @media only screen and (min-width: 768px) {
      min-width: 320px;
    }
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Text,
      name: 'Text',
      displayValue: ({ label }) => label ?? 'Date',
    },
    {
      component: DatePicker,
      name: 'Date',
      bindings: ({ selectedDate, placeholder, isBorder }) => ({ selectedDate, placeholder, isBorder })
    },
  ]
})